import { ThTextAttribute } from './thtext-attribute';

/**
 * Extracts the 'field path' (a.k.a data source path) from a th:text attribute.
 *
 * Example (pre v1.0.1): ${positions_1_item.jobTitle} ?: 'DEFAULT STRING VALUE' =>  positions_1_item.jobTitle
 * <p />
 * Example: ${#strings.defaultString(candidates_2_item.displayFileAs, 'DEFAULT STRING VALUE')} => candidates_2_item.displayFileAs
 * <p />
 * Example: ${#temporals.format(positions_1_item.dateCreated_2, 'yyyy')} => positions_1_item.dateCreated_2
 * <p />
 * Example: ${#numbers.formatDecimal(positions_2_item.nonExecPackage2AmountTo, 0, 'COMMA', 0, 'POINT')} ?: 9876543.21 => positions_2_item.nonExecPackage2AmountTo
 * <p />
 * Will NOT work for nested functions (e.g. Conditional fields) such as: ${#strings.equals(#strings.formatString(bullhorn.Candidate.customInt3,false,'NONE',-1,-1,-1,-1,'NONE'), '102')}
 */
export class ThTextFieldPathExtractor {
  private static readonly STRING_REGEX = /^\${([\w_.]+)}(.*)$/;
  private static readonly FUNCTION_REGEX = /^\${#([\w.]+)\(([\w_.]+)([\w\s.,'-\[\]]*)\)}(.*)$/;

  static fromAttribute(thText: string): string {
    return ThTextFieldPathExtractor.parse(thText);
  }

  static fromElement(element: Element): string {
    const thText = element.getAttribute(ThTextAttribute.QUALIFIED_NAME);
    if (!thText) {
      throw new Error(`No ${ThTextAttribute.QUALIFIED_NAME} on element '${element.tagName}'.`);
    }
    return ThTextFieldPathExtractor.fromAttribute(thText);
  }

  private static parse(thText: string): string {
    // pre v1.0.1 fields of type string
    const stringMatch = thText.match(ThTextFieldPathExtractor.STRING_REGEX);
    if (stringMatch?.length === 3) {
      return stringMatch[1];
    }

    // post v1.0.1 fields of try string use the #strings function
    const functionMatch = thText.match(ThTextFieldPathExtractor.FUNCTION_REGEX);
    if (functionMatch?.length === 5) {
      return functionMatch[2];
    }

    throw new Error(`Failed to parse attribute: '${thText}'.`);
  }
}
